import { connect } from 'react-redux';
import { saveRoomPreferences } from '../modules/tour';

import TourHotelSendTab from './TourHotelSendTab';

const mapDispatchToProps = {
  saveRoomPreferences,
};

const mapStateToProps = state => ({
  brandList: state.tours.brands,
});

export default connect(mapStateToProps, mapDispatchToProps)(TourHotelSendTab);



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelSendTabContainer.js